import { render, staticRenderFns } from "./TagButton.vue?vue&type=template&id=18ec754b&scoped=true&"
import script from "./TagButton.vue?vue&type=script&lang=js&"
export * from "./TagButton.vue?vue&type=script&lang=js&"
import style0 from "./TagButton.vue?vue&type=style&index=0&id=18ec754b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec754b",
  null
  
)

export default component.exports